import { useEffect, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useNavigate } from 'react-router-dom'

import MainLoader from 'ageas-react-component-loader'
import MessagesList from 'ageas-react-component-message-list'

import { DiscountCampaings } from '../../@types/RunPetisSimulation'
import { FooterBar } from '../../Components/FooterBar'
import { SafeAnimalsPackageTable } from '../../Components/SafeAnimalsPackageTable'
import { Container } from '../../Components/SafeAnimalsPackageTable/styles'
import { SimulationData } from '../../Components/SimulationData'
import { SimulationReport } from '../../Components/SimulationReport'
import { MainContainer } from '../../GlobalStyles'
import { useProgressStore } from '../../Stores/progressStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useCreateProposalStore } from '../../Stores/useCreateProposalStore'
import { useGetQuotationStore } from '../../Stores/useGetQuotationStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'
import { useWarningStore } from '../../Stores/warningStore'
import { ROUTES } from '../../constants/routes'
import { SESSION_STORAGE } from '../../constants/sessionStorage'
import { WARNING_BAR } from '../../constants/warningBar'
import { useCreateProposal as useCreateProposalRequest } from '../../hooks/api/createProposal/useCreateProposal'
import { useCreateProposalPayload } from '../../hooks/api/createProposal/useCreateProposalPayload'
import { useRecalculatePremium } from '../../hooks/api/recalculatePremium/useRecalculatePremium'
import { useRecalculatePremiumPayload } from '../../hooks/api/recalculatePremium/useRecalculatePremiumPayload'
import { useReferrals } from '../../hooks/useReferrals'
import { SimulationDataContainer, SimulationResultsContainer } from './style'

const elementPortal = document.getElementsByTagName('body')?.[0]

export const SimulationResult = () => {
  const navigate = useNavigate()
  const [showSimulationReport, setShowSimulationReport] = useState(false)
  const { setCurrentStep } = useProgressStore()
  const {
    setIsRecalculate,
    resetTotalPricesObjects,
    resetHasRecalculate,
    isFullStop,
    currentPack,
    setIsFullStop,
  } = useSimulatorStore()
  const {
    isReferral,
    runPetisSimulation,
    isRequestLoading,
    setIsRequestLoading,
    setIsReferral,
    selectedPackCampaign,
    setPreviousPackCampaign,
  } = useRunPetisSimulationStore()
  const { recalculatePremiumPayload } = useRecalculatePremiumPayload()
  const { createProposalPayload } = useCreateProposalPayload()
  const { handleReferralsMessages } = useReferrals()
  const { disabledStepsByResume } = useResumeStore()
  const { hasCreatedProposal, setHasCreatedProposal } = useCreateProposalStore()
  const { getQuotation } = useGetQuotationStore()

  const {
    mutate: mutateRecalculatePremium,
    isSuccess: isSuccessRecalculatePremium,
    isLoading: isLoadingRecalculatePremium,
    reset: resetRecalculatePremium,
  } = useRecalculatePremium()
  const { setWarningOptions } = useWarningStore()
  const { mutate, isSuccess, isLoading } = useCreateProposalRequest()
  const { disabledFullStop, enabledPacks } = useReferrals()

  const handleReferrals = () => {
    if (enabledPacks.includes(Object.values(currentPack)?.[0]) && isFullStop) {
      setIsReferral(false)
      setIsFullStop(false)

      setWarningOptions({
        labelTypes: [],
        mode: WARNING_BAR.mode.hide,
        modal: false,
      })
    }
  }

  const handleContinue = () => {
    if (disabledFullStop) return

    if (hasCreatedProposal || disabledStepsByResume.step2) {
      handleReferrals()
      navigate(ROUTES.ownerData)
    } else {
      mutate(createProposalPayload)
    }
  }

  const handleRecalculate = () => {
    resetTotalPricesObjects()
    mutateRecalculatePremium(recalculatePremiumPayload)
    setHasCreatedProposal(false)
  }

  useEffect(() => {
    if (isSuccessRecalculatePremium) {
      const oldRpsQuoteId = sessionStorage.getItem(
        SESSION_STORAGE.oldRpsQuoteId,
      )

      setPreviousPackCampaign(selectedPackCampaign as DiscountCampaings)

      if (
        (oldRpsQuoteId || '')?.length > 0 &&
        oldRpsQuoteId !==
          runPetisSimulation?.runPetisSimulationResponse?.quoteId
      ) {
        setHasCreatedProposal(false)

        sessionStorage.setItem(
          SESSION_STORAGE.oldRpsQuoteId,
          runPetisSimulation?.runPetisSimulationResponse?.quoteId || '',
        )
      }

      setIsRecalculate(false)
      resetRecalculatePremium()
    }
  }, [isSuccessRecalculatePremium, selectedPackCampaign])

  useEffect(() => {
    if (isSuccess) {
      handleReferrals()
      navigate(ROUTES.ownerData)
    }
  }, [isSuccess, navigate])

  useLayoutEffect(() => {
    setCurrentStep(2)
  }, [setCurrentStep])

  return (
    <Container isFullStop={isFullStop}>
      <MainLoader show={isLoading || isLoadingRecalculatePremium} />
      <SimulationResultsContainer>
        <MainContainer>
          <SimulationDataContainer>
            <SimulationData
              loading={isRequestLoading}
              disabled={disabledStepsByResume.step2 || hasCreatedProposal}
            />
          </SimulationDataContainer>
        </MainContainer>
        <SafeAnimalsPackageTable
          isLoadingRecalculate={isLoadingRecalculatePremium}
          setLoading={setIsRequestLoading}
        />
        {/* {!isRequestLoading && (
          <MainContainer>
            <QuotationContainer>
              {Boolean(getQuotation?.policyQuotation?.quotationId) && (
                <QuoteRequestStatus
                  type={
                    getQuotationStatus(
                      getQuotation?.policyQuotation?.status || '',
                    ).status
                  }
                  typeMessage={
                    getQuotationStatus(
                      getQuotation?.policyQuotation?.status || '',
                    ).message
                  }
                >
                  <Approved />
                </QuoteRequestStatus>
              )}
            </QuotationContainer>
          </MainContainer>
        )} */}
      </SimulationResultsContainer>
      {isReferral && (
        <MessagesList
          id="referralsMessage"
          type="error"
          list={handleReferralsMessages()}
          version="2"
        />
      )}
      <FooterBar
        isLoading={isRequestLoading || isLoading}
        isDisabled={disabledFullStop}
        setShowSimulationReport={setShowSimulationReport}
        onActionClick={() => {
          handleContinue()
        }}
        onRecalculateActionClick={() => {
          handleRecalculate()
          resetHasRecalculate()
        }}
      />
      {createPortal(
        <>
          <SimulationReport
            isVisible={showSimulationReport}
            closeAction={() => setShowSimulationReport(false)}
          />
        </>,
        elementPortal!,
      )}
    </Container>
  )
}
